import { LineIconType } from 'widgets/Lines/LineIconWidget/LineIconWidget.types';
import { LineWidgetTypes } from 'widgets/Lines/LineWidget/LineWidget.types';
import { DefaultTextType } from 'widgets/TextBasedWidgets/TextWidget/TextWidget.types';

export const ELEMENT_WIDGET_VERSION = 1;

export const DEFAULT_ELEMENT_WIDGET_DATA = {
  widthPx: 100,
  heightPx: 100,
  topPx: 0,
  leftPx: 0,
  rotateDeg: 0,
  componentWidgetIdMap: {},
  memberWidgetIds: [],
  version: ELEMENT_WIDGET_VERSION,
};

export const DEFAULT_ICON_DATA = {
  iconId: 'icons8-7801',
  viewBox: '0 0 20 20',
  topPxOverride: 0,
  leftPxOverride: 0,
  mono: false,
  iconConfig: {},
};

export const DEFAULT_TEXT_DATA = {
  textType: 'paragraph' as DefaultTextType,
  text: 'i am a text block element',
  hasLink: false,
};

export const DEFAULT_LINE_DATA = {
  lineType: LineWidgetTypes.straight,
};

export const DEFAULT_LINE_ICON_DATA = {
  lineType: LineIconType.HalfCurve,
};
